import React from 'react';
import { parse } from 'qs';
import Cookies from 'js-cookie';
import { Tree } from 'antd';

export function fixedZero(val) {
  return val * 1 < 10 ? `0${val}` : val;
}

export function separateByThousand(number, precision = 2) {
  if (!number) return 0;
  if (typeof number === 'number') {
    return number.toLocaleString('en-US', { maximumFractionDigits: precision });
  }

  if (typeof number === 'string') {
    const [integer, fraction] = number.split('.');
    const regx = /(?=(\d{3})+(?!\d))\B/g;
    const integerResult = integer.replace(regx, ',');
    if (fraction !== undefined) {
      return `${integerResult}.${fraction}`;
    }
    return integerResult;
  }
  throw new Error(`${this.name} input argument [number] has an illegal type: ${typeof number}`);
}

/**
 * render Money in table
 * @param {String} text
 * @param {string} unit
 */
export function renderMoney(text, unit = '万') {
  const precision = unit === '万' ? 6 : 2;
  const num = unit === '万' ? Number(text) / 10000 : text;
  return (
    <div style={{ color: 'orange' }}>
      {separateByThousand(num, precision)}
      {unit === '万' ? ' 万元' : ' 元'}
    </div>
  );
}

export function renderMoneyUnUnit(text, unit = '万') {
  const precision = unit === '万' ? 6 : 2;
  const num = unit === '万' ? Number(text) / 10000 : text;
  return <div style={{ color: 'orange' }}>{separateByThousand(num, precision)}</div>;
}

export function getPlainNode(nodeList, parentPath = '') {
  const arr = [];
  nodeList.forEach((node) => {
    const item = node;
    item.path = `${parentPath}/${item.path || ''}`.replace(/\/+/g, '/');
    item.exact = true;
    if (item.children && !item.component) {
      arr.push(...getPlainNode(item.children, item.path));
    } else {
      if (item.children && item.component) {
        item.exact = false;
      }
      arr.push(item);
    }
  });
  return arr;
}

export function digitUppercase(n) {
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  const head = n < 0 ? '欠' : '';
  let num = Math.abs(n);
  let s = '';
  for (let i = 0; i < fraction.length; i += 1) {
    s += (digit[Math.floor(num * 10 ** (i + 1)) % 10] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  num = Math.floor(num);
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = '';
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  );
}

export function getPageQuery() {
  return parse(window.location.href.split('?')[1]);
}

/**
 *  return Array from start to end(exclude)
 * @param {Number} start
 * @param {Number} end
 * @return {Number[]}
 * @description 生成从start到end(不包含)的数字数组
 */
export function range(start, end) {
  const result = [];
  for (let i = start; i < end; i += 1) {
    result.push(i);
  }
  return result;
}


/**
 * @param {Array} data, 数据集
 * @param {String} titleAttrName, 标题的字段名称
 * @param {String} valueAttrName, 值的字段名称
 * @return {ReactNode[]| undefined}
 * @description 生成tree的树节点,
 */
export function renderTreeNodes(data, titleAttrName = 'title', valueAttrName = 'id') {
  if (data === null || data === undefined) return <></>;
  if (!Array.isArray(data)) {
    console.error('renderTreeNodes: argument1 must be an array.');
    return <></>;
  }
  return data.map((item) => (
    <Tree.TreeNode
      title={item[titleAttrName]}
      key={item.key || item.id || item[valueAttrName]}
      value={item[valueAttrName]}
      icon={item.icon}
      disabled={item.disabled}
      selectable={item.selectable}
      ifLeaf={!item.children}
    >
      {renderTreeNodes(item.children, titleAttrName, valueAttrName)}
    </Tree.TreeNode>
  ));
}

/**
 * 浏览器类型及版本
 */
export function getBrowserInfo() {
  const agent = navigator.userAgent.toLowerCase();
  const regStrFf = /firefox\/[\d.]+/gi;
  const regStrChrome = /chrome\/[\d.]+/gi;
  const regStrSaf = /safari\/[\d.]+/gi;
  const isIE = agent.indexOf('compatible') > -1 && agent.indexOf('msie' > -1); // 判断是否IE<11浏览器
  const isIE11 = agent.indexOf('trident') > -1 && agent.indexOf('rv:11.0') > -1;
  if (isIE) {
    const reIE = new RegExp('msie (\\d+\\.\\d+);');
    reIE.test(agent);
    const fIEVersion = parseFloat(RegExp.$1);
    if (fIEVersion === 7) {
      return 'IE/7';
    }
    if (fIEVersion === 8) {
      return 'IE/8';
    }
    if (fIEVersion === 9) {
      return 'IE/9';
    }
    if (fIEVersion === 10) {
      return 'IE/10';
    }
  } // isIE end
  if (isIE11) {
    return 'IE/11';
  }
  // firefox
  if (agent.indexOf('firefox') > 0) {
    return agent.match(regStrFf);
  }
  // Safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    return agent.match(regStrSaf);
  }
  // Chrome
  if (agent.indexOf('chrome') > 0) {
    return agent.match(regStrChrome);
  }

  return 'unknown';
}

/**
 *
 * @return {string| undefined}
 * @description 返回当前储存的access token,
 * @deprecated 尽量使用useToken替代
 */
export function getToken() {
  return Cookies.get('mall-utk');
}

/**
 * @param {string} 身份证号码
 * @return {string} 隐藏后的身份证号码
 * @description 身份证加密方法
 */
export function hideId(idcard) {
  if (typeof idcard !== 'string') return '';
  if (idcard.length === 15) {
    return idcard.replace(/(\d{6})\d{6}(\d{3})/, '$1******$2');
  }
  return idcard.replace(/(\d{5})\d{6}(\d{6})/, '$1******$2');
}

/**
 *
 * @param bankCard 银行卡号
 * @description 格式化银行卡号规则
 */
export function formatCard(bankCard) {
  if (typeof bankCard !== 'string' || bankCard.length === 0) return '';
  return bankCard.replace(/\s/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
}

/**
 *
 * @param arr 数组
 * @param from 移动之前的index
 * @param to 移动之后的index
 * @description 数组元素移动
 */
export function arrayMove(arr, from, to) {
  const array = [...arr];
  const startIndex = from < 0 ? array.length + from : from;

  if (startIndex >= 0 && startIndex < array.length) {
    const endIndex = to < 0 ? array.length + to : to;

    const [item] = array.splice(from, 1);
    array.splice(endIndex, 0, item);
  }
  return array;
}

export function changeTableStyle(startHtml) {
  const regExp = new RegExp('<td ', 'ig');
  let newHtml = startHtml.replace(regExp, `<td style="border: 1px solid #262626;padding:4px"`);
  const regExpTr = new RegExp('<th ', 'ig');
  newHtml = newHtml.replace(
    regExpTr,
    `<th style="border: 1px solid #262626;background-color:#f0f0f0;padding:4px"`,
  );
  const regExpBody = new RegExp('<table style="table-layout: auto;">', 'ig');
  newHtml = newHtml.replace(regExpBody, `<table style="table-layout: auto;width:100%">`);

  return newHtml;
}

/**
 * 创建UUID
 */
export function generateUUID() {
  // Public Domain/MIT
  let d = new Date().getTime();
  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}
